import { Injectable, signal } from '@angular/core';

export type CopilotView = 'triage' | 'account';
export type CopilotPanel = 'briefing' | 'queue' | 'actions';

@Injectable({ providedIn: 'root' })
export class CopilotStore {
  readonly view = signal<CopilotView>('triage');
  /** Active panel on small screens where panels collapse into tabs. */
  readonly mobilePanel = signal<CopilotPanel>('briefing');
  readonly actionBanner = signal<string | null>(null);

  setView(view: CopilotView): void {
    this.view.set(view);
  }

  setMobilePanel(panel: CopilotPanel): void {
    this.mobilePanel.set(panel);
  }

  setActionBanner(message: string | null): void {
    this.actionBanner.set(message);
  }
}
